import * as checkboxHelper from '@sparta.global.helpers/checkbox-helper/dist/es6.js';
import * as comparisonsHelper from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import * as jsonHelper from '@sparta.global.helpers/json-helper/dist/es6.js';
import * as pictureHelper from '@sparta.global.helpers/picture-helper/dist/es6.js';
import * as radioButtonHelper from '@sparta.global.helpers/radio-button-helper/dist/es6.js';
import * as selectHelper from '@sparta.global.helpers/select-helper/dist/es6.js';
import * as spartaHelper from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import * as buttonHelper from '@sparta.global.helpers/button-helper/dist/es6.js';
import * as circleButtonHelper from '@sparta.global.helpers/circle-button-helper/dist/es6.js';
import * as textInputsHelper from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import * as currencyHelper from '@sparta.global.helpers/currency-helper/dist/es6.js';
import * as utilsHelper from '@sparta.global.helpers/utils-helper/dist/es6.js';
import * as svgHelper from '@sparta.global.helpers/svg-helper/dist/es6.js';
import * as textMaskingHelper from '@sparta.global.helpers/text-masking-helper/dist/es6.js';
import * as equalHelper from '@sparta.global.helpers/equal-helper/dist/es6.js';
import * as showHideHelper from '@sparta.global.helpers/show-hide-helper/dist/es6.js';
import * as squeezeboxHelper from '@sparta.global.helpers/squeezebox-helper/dist/es6.js';
import * as dmaHelper from '@sparta.digital-mortgage-application.helpers/digital-mortgage-application-helper/dist/es6.js';
import hbs from '@sparta.global.vendors/handlebars';
import Redux from '@sparta.global.vendors/redux';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import formsUtility from '@sparta.digital-mortgage-application.utilities/dma-forms-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-input-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import dmaCartUtility from '@sparta.digital-mortgage-application.utilities/cart-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import animationUtility from '@sparta.digital-mortgage-application.utilities/animation-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import spartaInputErrorUtility from '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import SpartaMessageUtility from '@sparta.global.utilities/sparta-messaging-utility/dist/es6.js';
import ajaxUtility from '@sparta.digital-mortgage-application.utilities/ajax-utility/dist/es6.js';
import moment from '@sparta.global.vendors/moment';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';

/**
 * Note - this code was moved from style-utility to workflow-utility
 * during the Sparta V6 migration due to the requirement that no
 * style-utility may have javascript code included.
 */

/**
 * @name        Style Utility
 * @file        style-utility.js
 * @description DMA common styles
 * @classdesc   DMA common styles
 * @global      Creates a global StyleUtility object
 * @author      nbdzrui
 * @copyright   © 2017 Bank of America Corporation. All rights reserved.
 */

class StyleUtility {
  getHelpers() {
    const helpers = {
      testHelper: () => 'test',
      house: () => `<div class="house-background">
            <div class="house">
              <div class="roof"></div>
              <div class="structure"></div>
              <div class="chimney"></div>
              <div class="structure-bottom-half-fill"></div>
              <div class="bottom-to-structure-fill"></div>
              <div class="bottom-from-structure-fill"></div>
              <div class="top-from-structure-fill-sixty"></div>
              <div class="top-from-structure-fill-seventy"></div>
              <div class="top-from-structure-fill-eighty"></div>
              <div class="top-from-structure-fill-ninety"></div>
              <div class="top-from-structure-fill-ninety"></div>
              <div class="top-to-structure-fill-sixty"></div>
              <div class="top-to-structure-fill-seventy"></div>
              <div class="top-to-structure-fill-eighty"></div>
              <div class="top-to-structure-fill-ninety"></div>
              <div class="top-to-structure-fill-one-hundred"></div>
            </div>
          </div>`,
      ifCond: (v1, operator, v2, options) => {
        switch (operator) {
          case '==':
            return v1 == v2 ? options.fn(this) : options.inverse(this);
          // eslint-disable-line
          case '===':
            return v1 === v2 ? options.fn(this) : options.inverse(this);
          case '<':
            return v1 < v2 ? options.fn(this) : options.inverse(this);
          case '<=':
            return v1 <= v2 ? options.fn(this) : options.inverse(this);
          case '>':
            return v1 > v2 ? options.fn(this) : options.inverse(this);
          case '>=':
            return v1 >= v2 ? options.fn(this) : options.inverse(this);
          case '&&':
            return v1 && v2 ? options.fn(this) : options.inverse(this);
          case '||':
            return v1 || v2 ? options.fn(this) : options.inverse(this);
          default:
            return options.inverse(this);
        }
      },
      splitPascalCase: s => s.replace(/([A-Z])/g, ' $1').trim()
    };
    return helpers;
  }
}

/**
 * @const StyleUtility
 * @description single isntance of StyleUtility used to expose this utility
 */
const styleUtility = new StyleUtility();

const constants = ['INIT', 'SUBMIT', 'GO_BACK', 'ROUTE_UPDATED', 'UPDATE_ROUTE', 'PREVIOUS_ROUTE', 'IS_GO_BACK', 'UPDATE_MOCK_SCENARIOS', 'ADD_RENDER_ACTION', 'DATA_RECEIVED', 'DATA_SUBMITTED', 'UPDATE_COUNTRY_LISTS', 'DUAL_CITIZENSHIP', 'CITIZENSHIP', 'UPDATE_OCCUPATION_LIST', 'UPDATE_RESIDENCY_TYPE_LIST', 'UPDATE_RESIDENCY_DOCUMENT_LIST', 'RESIDENCE', 'UPDATE_PARTIALS', 'UPDATE_DATA_SOURCES', 'BEHAVE_LIKE_ROUTE_CHANGE', 'IS_RENDER_LOCAL', 'PHONE_NUMBER_RECEIVED', 'MLO_DETAILS_RECEIVED', 'IN_FLIGHT', 'UPDATE_CART_RETRIEVED', 'UPDATE_ON_UNMOUNT_EVENT'];
var constants$1 = _.fromPairs(constants.map(constant => [constant, constant]));

/* global window, spaParams */
const routes = {};
function routeHelper(hash) {
  let routeName;
  if (hash) {
    if (hash.indexOf('#') === 0) {
      routeName = hash.split('#')[1];
    } else {
      routeName = hash.toLowerCase();
    }
  }
  return {
    ...routes[routeName],
    routeName
  };
}
function putRoute(routeName, routeConfig) {
  routes[routeName] = routeConfig;
}
function getCurrentRoute$1() {
  return routeHelper(window.location.hash);
}
function getPreviousRoute(oldUrl) {
  const oldHash = `#${oldUrl.split('#')[1]}`;
  return routeHelper(oldHash);
}
function getRoute(routeName) {
  return routeHelper(routeName);
}
function isKnownRoute(routeName) {
  const knownRoute = _.has(routes, routeName);
  return knownRoute;
}
var routes$1 = {
  getCurrentRoute: getCurrentRoute$1,
  getPreviousRoute,
  getRoute,
  isKnownRoute,
  putRoute
};

// This is used to validate zip codes with a chosen state, based on the ranges defined below.
var statesAndZipCodes = {
  AK: {
    ranges: [{
      start: 99500,
      end: 99999
    }]
  },
  AL: {
    ranges: [{
      start: 35000,
      end: 36999
    }]
  },
  AR: {
    ranges: [{
      start: 71600,
      end: 72999
    }]
  },
  AZ: {
    ranges: [{
      start: 85000,
      end: 86599
    }]
  },
  CA: {
    ranges: [{
      start: 90000,
      end: 96199
    }]
  },
  CO: {
    ranges: [{
      start: 80000,
      end: 81699
    }]
  },
  CT: {
    ranges: [{
      start: 6000,
      end: 6999
    }]
  },
  DC: {
    ranges: [{
      start: 20000,
      end: 20099
    }, {
      start: 20200,
      end: 20599
    }]
  },
  DE: {
    ranges: [{
      start: 19700,
      end: 19999
    }]
  },
  FL: {
    ranges: [{
      start: 32000,
      end: 33999
    }, {
      start: 34100,
      end: 34999
    }]
  },
  GA: {
    ranges: [{
      start: 30000,
      end: 31999
    }, {
      start: 39813,
      end: 39999
    }]
  },
  HI: {
    ranges: [{
      start: 96700,
      end: 96899
    }]
  },
  IA: {
    ranges: [{
      start: 50000,
      end: 52899
    }]
  },
  ID: {
    ranges: [{
      start: 83200,
      end: 83899
    }]
  },
  IL: {
    ranges: [{
      start: 60000,
      end: 62999
    }]
  },
  IN: {
    ranges: [{
      start: 46000,
      end: 47999
    }]
  },
  KS: {
    ranges: [{
      start: 66000,
      end: 67999
    }]
  },
  KY: {
    ranges: [{
      start: 40000,
      end: 42799
    }]
  },
  LA: {
    ranges: [{
      start: 70000,
      end: 71499
    }]
  },
  MA: {
    ranges: [{
      start: 1000,
      end: 2799
    }, {
      start: 5500,
      end: 5599
    }]
  },
  MD: {
    ranges: [{
      start: 20600,
      end: 21999
    }]
  },
  ME: {
    ranges: [{
      start: 3900,
      end: 4999
    }]
  },
  MI: {
    ranges: [{
      start: 48000,
      end: 49999
    }]
  },
  MN: {
    ranges: [{
      start: 55000,
      end: 56799
    }]
  },
  MO: {
    ranges: [{
      start: 63000,
      end: 65899
    }]
  },
  MS: {
    ranges: [{
      start: 38600,
      end: 39799
    }]
  },
  MT: {
    ranges: [{
      start: 59000,
      end: 59999
    }]
  },
  NC: {
    ranges: [{
      start: 27000,
      end: 28999
    }]
  },
  ND: {
    ranges: [{
      start: 58000,
      end: 58899
    }]
  },
  NE: {
    ranges: [{
      start: 68000,
      end: 69399
    }]
  },
  NH: {
    ranges: [{
      start: 210,
      end: 215
    }, {
      start: 3000,
      end: 3899
    }]
  },
  NJ: {
    ranges: [{
      start: 7000,
      end: 8999
    }]
  },
  NM: {
    ranges: [{
      start: 87000,
      end: 88499
    }]
  },
  NV: {
    ranges: [{
      start: 88900,
      end: 89899
    }]
  },
  NY: {
    ranges: [{
      start: 401,
      end: 544
    }, {
      start: 6390,
      end: 6390
    }, {
      start: 10000,
      end: 14999
    }]
  },
  OH: {
    ranges: [{
      start: 43000,
      end: 45999
    }]
  },
  OK: {
    ranges: [{
      start: 73000,
      end: 73199
    }, {
      start: 73400,
      end: 74999
    }]
  },
  OR: {
    ranges: [{
      start: 97000,
      end: 97999
    }]
  },
  PA: {
    ranges: [{
      start: 15000,
      end: 19699
    }]
  },
  RI: {
    ranges: [{
      start: 2800,
      end: 2999
    }]
  },
  SC: {
    ranges: [{
      start: 29000,
      end: 29999
    }]
  },
  SD: {
    ranges: [{
      start: 57000,
      end: 57799
    }]
  },
  TN: {
    ranges: [{
      start: 37000,
      end: 38599
    }]
  },
  TX: {
    ranges: [{
      start: 73300,
      end: 73399
    }, {
      start: 75000,
      end: 79999
    }, {
      start: 88500,
      end: 88599
    }]
  },
  UT: {
    ranges: [{
      start: 84000,
      end: 84799
    }]
  },
  VA: {
    ranges: [{
      start: 20100,
      end: 20199
    }, {
      start: 22000,
      end: 24699
    }]
  },
  VT: {
    ranges: [{
      start: 5000,
      end: 5499
    }, {
      start: 5600,
      end: 5999
    }]
  },
  WA: {
    ranges: [{
      start: 98000,
      end: 99499
    }]
  },
  WI: {
    ranges: [{
      start: 53000,
      end: 54999
    }]
  },
  WV: {
    ranges: [{
      start: 24700,
      end: 26899
    }]
  },
  WY: {
    ranges: [{
      start: 82000,
      end: 83199
    }]
  }
};

/* global spaParams */

// input as numbers, month is 0 index based, January = 0, December = 11

// all available custom validations are stored in this object
const validationFunctions = {};

/*
NOTE: custom validations
*/

/**
 * This compares two dates, returning: -1 if date1 < date2, 0 if both dates are equal, and 1 if
 * date1 > date2
 * @param {string} date1 - date string formated with slashes
 * @param {string} date2 - date string formated with slashes
 * @returns {number}
 */
function compareDates(date1, date2) {
  let comparisionType = 0;
  const modifiedDate1 = new Date(date1.split('/').reverse().join('-'));
  const modifiedDate2 = new Date(date2.split('/').reverse().join('-'));
  if (modifiedDate1 > modifiedDate2) {
    comparisionType = 1;
  } else if (modifiedDate1 < modifiedDate2) {
    comparisionType = -1;
  }
  return comparisionType;
}

/**
 * This creates and returns a native browser event
 * @param {string} eventName - name of event being created
 * @returns {event}
 */
function createNewEvent(eventName) {
  let event;
  if (typeof Event === 'function') {
    event = new Event(eventName);
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }
  return event;
}

/**
 * Compares two dates, returns false if validation fails based on criteria passed in arguments
 * @param {object} $targetEle - jQuery object of element whose value to be used for date value
 * @param {string} type - name of event being created, start if eventName should be less than,
 * and any other value if it should be greater
 * @returns {boolean}
 */
function validateStartAndEndDate($targetEle, type) {
  let hasValidDate;
  const targetDate = $targetEle.val();
  const targetEleId = $targetEle.attr('id');
  let dependentFieldId = $targetEle.attr('data-dependentField');
  if (!dependentFieldId) {
    return true;
  }
  if (targetEleId.includes('-')) {
    const index = $targetEle.attr('id').split('-').pop();
    dependentFieldId = `${dependentFieldId}-${index}`;
  }
  const dependentEle = document.querySelector(`#${dependentFieldId}`);
  const hasDependentEleComparisonError = dependentEle.classList.contains('date-comparison-error');
  const isSpartaValidationError = !hasDependentEleComparisonError && dependentEle.classList.contains('spa-error-form-input--validation');
  hasValidDate = !dependentEle.value || isSpartaValidationError;
  if (!hasValidDate) {
    const comparisonValue = type === 'start' ? -1 : 1;
    hasValidDate = compareDates(targetDate, dependentEle.value) === comparisonValue;
    if (!hasValidDate) {
      $targetEle.addClass('date-comparison-error');
    } else {
      $targetEle.removeClass('date-comparison-error');
      if (hasDependentEleComparisonError) {
        const changeEvent = createNewEvent('change');
        dependentEle.dispatchEvent(changeEvent);
      }
    }
  }
  return hasValidDate;
}

/**
 * validates that date comes before dependentField date. End date is an element that should be
 * defined in data-dependentField attribute on input element.
 * @param {object} $targetEle - jQuery object of element whose value to be used for date value
 * @returns {boolean}
 */
validationFunctions.startDateValidation = $targetEle => validateStartAndEndDate($targetEle, 'start');

/**
 * validates that date comes after dependentField date. End date is an element that should be
 * defined in data-dependentField attribute on input element.
 * @param {object} $targetEle - jQuery object of element whose value to be used for date value
 * @returns {boolean}
 */
validationFunctions.endDateValidation = $targetEle => validateStartAndEndDate($targetEle, 'end');

/**
 * Gets the age based on date passed in
 * @param {number} y - year
 * @param {number} m - month
 * @param {number} d - day
 * @returns {number}
 */
function calculateAge(y, m, d) {
  const bd = new Date(y, m, d);
  const todaysDate = new Date();
  const getDoY = day => {
    const today = new Date(day.getFullYear(), 0, 1);
    return Math.floor((day - today) / 86400000 + 1);
  };
  function isLeap(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  }
  let age = todaysDate.getFullYear() - bd.getFullYear();
  let doyNow = getDoY(todaysDate);
  let doyBirth = getDoY(bd);

  // normalize day-of-year in leap years
  if (isLeap(todaysDate.getFullYear()) && doyNow > 58 && doyBirth > 59) doyNow -= 1;
  if (isLeap(bd.getFullYear()) && doyNow > 58 && doyBirth > 59) doyBirth -= 1;
  if (doyNow <= doyBirth) age -= 1; // birthday not yet passed this year, so -1

  return age;
}

/**
 * validates that age based on date was born after january 1st 1902 and at least 18 years old
 * @param {object} $element - jQuery object of element whose value to be used for date value
 * @returns {object}
 */
validationFunctions.validateAge = $element => {
  const minAge = 18;
  let errorMessage = 'Applicant must be at least 18 years of age to apply in most cases.  Contact your lending specialist or use the help icon for further information regarding your application.';
  const birthDate = new Date($element.val());
  const todaysDate = new Date();

  // based off a business requirement, the applicant must be born on or after 01/01/1902
  const minDate = new Date(1902, 0, 1); // January = 0

  if (birthDate <= minDate) {
    errorMessage = 'Please enter a valid 2-digit day, 2-digit month and 4-digit year.';
  } else if (birthDate < todaysDate) {
    const userAge = calculateAge(birthDate.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    if (minAge <= userAge) {
      return true;
    }
  }
  return {
    errorMessage
  };
};
validationFunctions.isDateInFuture = $elem => {
  const value = $elem.val();
  const [monthToken, yearToken] = value.split('/');
  const month = parseInt(monthToken, 10);
  const year = parseInt(yearToken, 10);
  const date = new Date();
  date.setMonth(month - 1);
  date.setFullYear(year);
  date.setDate(date.getDate() + 1);
  const now = new Date();
  return date.getTime() > now.getTime();
};

/**
 * Seems to be a place holder, always returns true
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.startDateAtAddressValidation = () => true;
// validationFunctions.startDateAtAddressValidation = ($element) => {
// const date = $element.val().split('/').reverse().join('-');
// const refDate = $element.attr('data-refDate');
// const isPastDate = moment(date).isSameOrAfter(refDate);
// return true;
// };

/**
 * This checks that a field is alphanumeric plus only hyphens (-), periods (.), apostrophe ('). It
 * also checks that is is not only special characters
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
function alphaNumericWithSpecialChars($element) {
  const val = $element.val();

  // ensure only alphanumeric plus '-.
  if (val.replace(/[0-9a-z'\-. ]/gi, '').length > 0) {
    return false;
  }

  // ensure it is not just special characters
  if (val.length > 0 && val.replace(/[^0-9a-z]/gi, '').length === 0) {
    return false;
  }
  return true;
}

/**
 * This checks that a field is alphanumeric plus only hyphens (-), periods (.), apostrophe ('),
 * hash (#). It also checks that is is not only special characters
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
function alphaNumericWithSpecialCharsForMailing($element) {
  const val = $element.val();

  // ensure only alphanumeric plus #'-.
  if (val.replace(/[0-9a-z#'\-. ]/gi, '').length > 0) {
    return false;
  }

  // ensure it is not just special characters
  if (val.length > 0 && val.replace(/[^0-9a-z]/gi, '').length === 0) {
    return false;
  }
  return true;
}

/**
 * This simply calls and returns the result of the alphaNumericWithSpecialChars method
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.cityNameValidation = $element => alphaNumericWithSpecialChars($element);

/**
 * This simply calls and returns the result of the alphaNumericWithSpecialChars method
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.streetNumberValidation = $element => alphaNumericWithSpecialChars($element);

/**
 * This simply calls and returns the result of the alphaNumericWithSpecialChars method
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.mailingAddressLineOneValidation = $element => alphaNumericWithSpecialCharsForMailing($element);

/**
 * This simply calls and returns the result of the alphaNumericWithSpecialChars method
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.mailingAddressLineTwoValidation = $element => alphaNumericWithSpecialCharsForMailing($element);

/**
 * Checks whether the address is a po box, if it is longer than 44 characters, that it contains at
 * least letters, numbers, -,., or space, and that it contains at least one word character
 * @param {object} $element - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.addressValidation = $element => {
  if ($element.val().toUpperCase().trim().startsWith('P.O.BOX') || $element.val().toUpperCase().startsWith('PO ') || $element.val().toUpperCase().startsWith('P.O.') || $element.val().toUpperCase().includes('PO BOX') || $element.val().toUpperCase().includes('POBOX') || $element.val().length > 44) {
    return false;
  }
  return /[a-zA-Z0-9'\-.\s]*/.test($element.val()) && /.*\w+.*/.test($element.val());
};

/**
 * This checks that a zip falls within the zip range of a chosen state
 * @param {object} zip - jQuery object of element
 * @param {string} id - id of state selector
 * @returns {boolean}
 */
function commonStateZipValidation(zip, id) {
  // if we have an id like "abc-0" then the state id will be "selectState-0"
  const zipId = zip.attr('id').match(/^(.*)(-\d+)$/) || [''];
  const state = $(`#${id}${zipId[zipId.length - 1]}`).val();
  // if zip field or state select is blank do not proceed
  if (zip === '' || !state) return;

  // Remove numbers after the dash and remove proceeding zeros
  const zipNumber = parseInt(zip.val().split(/\s*\-\s*/g)[0], 10); // eslint-disable-line
  const ranges = statesAndZipCodes[state].ranges;
  let returnVal = false;
  ranges.forEach(range => {
    if (zipNumber >= range.start && zipNumber <= range.end) {
      returnVal = true;
    }
  });
  return returnVal; // eslint-disable-line
}

/**
 * This simply calls and returns the result of the commonStateZipValidation method
 * @param {object} zip - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.stateZipValidation = zip => commonStateZipValidation(zip, 'selectState');

/**
 * This simply calls and returns the result of the commonStateZipValidation method
 * @param {object} zip - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.mailingAddressStateZipValidation = zip => commonStateZipValidation(zip, 'stateMailing');

/**
 * Checks that date is greater than current date
 * @param {object} $el - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.acquisitionDateValidation = $el => {
  const today = new Date();
  const current = new Date(today.getFullYear(), today.getMonth(), 1);
  const acquisitionDate = new Date($el.val().replace('/', '/01/'));
  if (acquisitionDate > current) {
    return false;
  }
  return true;
};

/**
 * Checks that date is not a weekend or holiday
 * @param {object} $el - jQuery object of element
 * @returns {boolean}
 */
validationFunctions.isNotWeekendOrHoliday = $el => {
  const val = $el.length && $el[0].value;
  const datedValue = `${new Date(val)}`;
  const holidays = spartaStoreUtility.getData('bankHolidays');
  const datedHolidays = holidays.map(holiday => `${new Date(holiday)}`);
  const dateIsNotBankHoliday = !datedHolidays.includes(datedValue);
  const dayOfWeek = moment(val, 'MM/DD/YYYY').format('dddd');
  const dateIsNotWeekend = dayOfWeek !== 'Sunday' && dayOfWeek !== 'Saturday';
  return dateIsNotWeekend && dateIsNotBankHoliday;
};

/*
NOTE: helper functions
*/

let filteredCustomValidationMap = {}; // eslint-disable-line import/no-mutable-exports

/**
 * This is the method called by any screen that wants to use custom validations.
 * @param {object} idsAndRulesMap - This maps an input field ID to a particular customValidation
 * @param {object} rules - This is will be passed by the module and comes from a jcr. It stores the
 * error message information
 * @param {Boolean} clearMap If true, clears existing validations.
 * @returns {void}
 */
function customClientValidationFunc(idsAndRulesMap, rules, clearMap = true) {
  spartaValidationFramework.init();
  const disableValidation = spartaGlobalFunctions.getUrlParam('clientValidationDisabled');
  const customClientValidationMap = rules;
  if (clearMap) filteredCustomValidationMap = {};
  Object.keys(rules).forEach(key => {
    const rule = rules[key];
    if (rule.change && rule.change.customFunction && rule.change.customFunction.parameters && rule.change.customFunction.parameters.customFunction && typeof rule.change.customFunction.parameters.customFunction === 'string') {
      rule.change.customFunction.parameters.customFunction = validationFunctions[rule.change.customFunction.parameters.customFunction];
    }
  });
  if (!spaParams.siteParams.isProd && disableValidation === 'true') {
    console.log('Client side validation has been disabled');
  } else {
    Object.keys(idsAndRulesMap).forEach(id => {
      const value = idsAndRulesMap[id];
      let rule;
      let params;
      let eventType;
      if (typeof value === 'object') {
        rule = value.rule;
        params = value.params;
        eventType = value.eventType || 'change';
        const validationRuleObj = customClientValidationMap[rule];
        validationRuleObj[eventType].customFunction.parameters.functionParams = params;
        filteredCustomValidationMap[id] = validationRuleObj;
      } else {
        rule = value;
        filteredCustomValidationMap[id] = customClientValidationMap[rule];
      }
    });
    spartaValidationFramework.fn.core.bindValidationRules(filteredCustomValidationMap, true);
  }
}

/**
 * executes field rules for zip field
 * @param {object} $zipcode - jQuery object of element
 * @returns {boolean}
 */
function customStateZipValidation($zipcode) {
  const val = $zipcode.val();
  if (val !== null && val.length === 5) {
    spartaValidationFramework.fn.core.validateAllFieldRules($zipcode);
  }
}

/**
 * This function applies the default ascii validation and <,>,=,; in inputs
 */
function defaultAsciiValidation() {
  return {
    change: [{
      customPattern: {
        parameters: {
          regexPattern: '^[\\x00-\\x3a\\x3f-\\x7f]+\\ *(?:^[\\x00-\\x3a\\x3f-\\x7f]| )*$'
        },
        errorMessage: 'Please enter a valid value.'
      }
    }]
  };
}

var customClientValidation = /*#__PURE__*/Object.freeze({
  __proto__: null,
  calculateAge: calculateAge,
  customClientValidationFunc: customClientValidationFunc,
  get filteredCustomValidationMap () { return filteredCustomValidationMap; },
  customStateZipValidation: customStateZipValidation,
  defaultAsciiValidation: defaultAsciiValidation
});

/* global spaParams */

// returns object of query parms; if duplicate name, will put values into array
// ex: { mock: local, test: [parm1, parm2] }
function getQueryParamValues$1(url = window.location.href) {
  const pattern = /([^\/\?\&\=]+\=[^\&\#]+)/g; // eslint-disable-line
  const matches = url.match(pattern);
  if (matches) {
    return matches.reduce((accum, e) => {
      const key = e.split('=')[0];
      const value = e.split('=')[1];
      // key exists
      if (accum[key]) {
        const val = accum[key];
        // value is already an array so add it
        if (Array.isArray(val)) {
          accum[key].push(value);
        } else {
          // value isn't an array so make it one
          accum[key] = [val, value]; // eslint-disable-line no-param-reassign
        }
      } else {
        // key doesn't exist
        accum[key] = value; // eslint-disable-line no-param-reassign
      }
      return accum;
    }, {});
  }
  return {};
}
function replaceValueRules(inp) {
  let updatedInp = inp;
  function replaceCustomRules(rule) {
    // 01/2012 --> 012012
    let updatedRule = rule.replace(/^(\d{2})(\/)(19|20)(\d{2})$/g, '$1$3$4');

    // 1,020 --> 1020, 1,230.02 --> 1230.02
    if (/^[0-9,?.]+$/.test(rule)) {
      updatedRule = updatedRule.replace(/[^0-9.]/g, '');
    }

    // ssn 183-39-2993 --> 183392993
    updatedRule = updatedRule.replace(/^(\d{3})(-)(\d{2})(-)(\d{4})$/g, '$1$3$5');
    return updatedRule;
  }

  // if not from form module then return
  if (!$('.current-view').is(':visible')) {
    return updatedInp;
  }
  if (typeof updatedInp === 'object') {
    // object
    const keys = _.isEmpty(updatedInp) ? [] : Object.keys(updatedInp);
    keys.forEach(key => {
      if (updatedInp[key]) {
        // array
        if (Array.isArray(updatedInp[key])) {
          for (let j = 0; j < updatedInp[key].length; j += 1) {
            updatedInp[key][j] = replaceValueRules(updatedInp[key][j]);
          }
        } else if (typeof updatedInp[key] === 'object') {
          // object
          const updatedInpKeys = _.isEmpty(updatedInp[key]) ? [] : Object.keys(updatedInp[key]);
          updatedInpKeys.forEach(key2 => {
            updatedInp[key][key2] = replaceValueRules(updatedInp[key][key2]);
          });
        } else if (typeof updatedInp[key] === 'string') {
          // string
          updatedInp[key] = replaceCustomRules(updatedInp[key]);
        }
      }
    });
  } else if (typeof updatedInp === 'string') {
    // string
    updatedInp = replaceCustomRules(updatedInp);
  }
  return updatedInp;
}
let clientSideErrorMessagesList = [];
function getErrMessage(data, type) {
  const targetElement = data.field.get(0);
  const dataKey = targetElement.tagName === 'FIELDSET' ? 'field' : 'label';
  const targetElementId = targetElement.id;
  const labelOrLegendElement = dataKey === 'field' ? targetElement.querySelector('legend') : data.label.get(0);
  return type === 'err' ? {
    [targetElementId]: `${$.trim(labelOrLegendElement.textContent)} : ${data.message}`
  } : targetElementId;
}
function addClientSideValidationError(validationObj) {
  const errMessage = getErrMessage(validationObj.data, 'err');
  const elementId = Object.keys(errMessage).shift();
  const isSameErrPresent = clientSideErrorMessagesList.find(messageObj => Object.keys(messageObj).shift() === elementId) !== undefined;
  if (!isSameErrPresent) {
    clientSideErrorMessagesList.push(errMessage);
  }
}
function removeClientSideValidationError(validationObj) {
  const succMessage = getErrMessage(validationObj.data, 'succ');
  if (clientSideErrorMessagesList.length) {
    clientSideErrorMessagesList = clientSideErrorMessagesList.filter(element => !element[succMessage]);
  }
}

//  subscribe to fail and success Sparta validation events
spartaEventsUtility.sub('FAIL_REQUIRED_FIELD_VALIDATION.spartaValidationFramework', addClientSideValidationError);
spartaEventsUtility.sub('PASS_REQUIRED_FIELD_VALIDATION.spartaValidationFramework', removeClientSideValidationError);
spartaEventsUtility.sub('FAIL_INPUT_VALIDATION.spartaValidationFramework', addClientSideValidationError);
spartaEventsUtility.sub('PASS_INPUT_VALIDATION.spartaValidationFramework', removeClientSideValidationError);

/**
 * A custom page level message utility extending the global sparta one.
 * This allows us to add a callback after the message has been attached to the DOM
 * to safely and robustly ensure the page level message is moved to the correct place.
 */
class CustomMessageUtility extends SpartaMessageUtility {
  /**
   * Creates the new custom message utility
   */
  constructor() {
    super();
    this.attachBroadcastListeners = [];
  }

  /**
   * Attaches the message to the DOM. This super method intercepts this and allows
   * us to attach a callback after the message is added to the DOM.
   * @param  {...any} args Arguments sent to Global Sparta.
   * @returns {Object} Superclass response
   */
  async attach(...args) {
    const returnValue = await super.attach(...args);
    this.broadcastAttachListeners();
    return returnValue;
  }

  /**
   * Adds **one-time** listeners/callbacks called when the message is attached
   * to the DOM.
   * @param {Function} listener A callback to be called only once
   * @returns {void}
   */
  addAttachListener(listener) {
    this.attachBroadcastListeners.push(listener);
  }

  /**
   * Broadcasts the attach event to all listeners and removes them afterwards.
   * @returns {void}
   */
  broadcastAttachListeners() {
    this.attachBroadcastListeners.forEach(fn => fn());
    this.attachBroadcastListeners = [];
  }
}

/**
 * Displays page-level error messages based on user's input and validations.
 * @param {$} $currentView Current route container.
 * @param {*} displayMessagesList [Deprecated]
 * @returns {void}
 */
function showPageLevelErrorMessage$1($currentView) {
  const routeContainerId = 'currentlyDisplayedRouteView';
  $currentView.attr('id', routeContainerId);
  const messageUtility = new CustomMessageUtility();
  // Add callback after the message is added to DOM to move it into container
  messageUtility.addAttachListener(() => {
    const pageLevelContainer = $('.page-level-message');
    pageLevelContainer.empty();
    $(`#sparta-message-${messageUtility._options.uuid}`).detach().appendTo(pageLevelContainer);
  });
  spartaInputErrorUtility.collectAndDisplayErrrors(routeContainerId, messageUtility);

  // TODO - Deal with server-side page level.

  // messageUtility.show(pageLevelContainer.get(0));
  // const spartaMessageUtil = new SpartaMessageUtility();
  // const pageLevelErrorMessage = 'Check and fix errors to continue'; // Page level generic error message
  // const $pageLevelMessageContainer = $('.page-level-message', $currentView);

  // // Show the page level error messages
  // $pageLevelMessageContainer.show();
  // spartaMessageUtil.showErrorMessage('.page-level-message', pageLevelErrorMessage, displayMessagesList, {
  //   insert: 'replace',
  //   listType: 'ordered',
  //   size: 'medium',
  // });
  // $('.spartaMessage-list', $pageLevelMessageContainer).addClass('ada-hidden');
  // //  Scroll the page to top
  // if ($currentView.hasClass('current-view')) {
  //   $('html, body').animate({ scrollTop: $pageLevelMessageContainer.offset().top - 15 }, 250);
  // }
  // $pageLevelMessageContainer.attr('tabindex', 0).focus(); //  Shifting focus to the page level error message
  // clearErrorMessagesList(); //  Clear the clientside error message array
}
function clearPageLevelErrorMessage$1($currentView) {
  clientSideErrorMessagesList = [];
  $('.page-level-message', $currentView).empty();
}
function addBackendValidation(validation) {
  const $currentView = $('.current-view');

  // remove all errors
  $('label', $currentView).removeClass('spa-error-form-label--validation');

  // fieldset is for radiobox errors
  $('input, select, fieldset', $currentView).each(function () {
    spartaInputErrorUtility.updateInlineError(false, {
      field: $(this),
      label: $(this).siblings('label')
    });
  });
  $('.page-level-message', $currentView).empty();
  const fieldErrorsArr = validation.fieldErrors;
  const serverSideErrorMessagesList = [];

  // loop through errors from server
  for (let i = 0; i < fieldErrorsArr.length; i += 1) {
    let id = fieldErrorsArr[i].elementId;
    let errorMessage = 'not mapped';
    let $selector;
    let typ = 'invalid';
    if (fieldErrorsArr[i].failedValidatorIds.length === 2) {
      typ = 'both';
    } else if (fieldErrorsArr[i].failedValidatorIds.join('').includes('required')) {
      typ = 'required';
    }
    // if elementId contains a period then we have a wrapper and need to
    // search on that first (ex: "elementId": "name.firstName")
    if (id.includes('.')) {
      const idArr = id.split('.');
      id = idArr[1];
      $selector = $('[name], fieldset', $currentView.find(`[data-dto-wrapper="${idArr[0]}"]`)).filter(function () {
        // just do a fuzzy search to ensure the id passed from the server is included
        return $(this).attr('id').toLowerCase().includes(id.toLowerCase()) || $(this).attr('class').replace(/-/g, '').toLowerCase().includes(id.toLowerCase());
      }).first();
    } else {
      // case insensitive on id match (field-set is for radio boxes)
      $selector = $('[name], [id],  fieldset', $currentView).filter(function () {
        const innerId = $(this).attr('id') || '';
        const innerName = $(this).attr('name') || '';
        return innerId.toLowerCase() === id.toLowerCase() || innerName.toLowerCase() === id.toLowerCase();
      }).first();
    }
    if (typ === 'required' || typ === 'both') {
      errorMessage = $selector.attr('data-required-error-message') || errorMessage;
      if (errorMessage === 'not mapped') {
        try {
          errorMessage = JSON.parse($selector.attr('data-server-validation') || '').required || errorMessage;
        } catch (error) {
          console.warn('Error: ', error);
        }
      }
    } else if (typ === 'invalid') {
      try {
        errorMessage = JSON.parse($selector.attr('data-server-validation') || '').invalid || errorMessage;
      } catch (error) {
        console.warn('Error: ', error);
      }
    }

    // for a radiobox we could be here so try to set the error message again
    if (errorMessage === 'not mapped') {
      errorMessage = $selector.attr('data-required-error-message') || errorMessage;
      if (errorMessage === 'not mapped') {
        errorMessage = 'Field is invalid';
      }
    }

    // set error
    spartaValidationFramework.fn.core.handleFieldError($selector, 'error', errorMessage);

    // need to add a class that isn't added when you use the "updateInlineError" method
    // $selector.siblings('label').addClass('spa-error-form-label--validation');
    // $selector.find('label').addClass('spa-error-form-label--validation');
    // search for all labels who start with selected element id
    // $(`label[for^='${$selector.attr('id')}']`, $currentView).addClass('spa-error-form-label--validation');
  }

  // define getKey function, which is sued below to write server side error messages at top of page
  function getKey($elem) {
    // most fields we can get label from label but radio boxes come from legend
    const $selector = $elem.siblings('label').length ? $elem.siblings('label') : $elem.closest('fieldset').find('legend');
    let key = $selector.text();
    // strip out any ada hidden span text in siblings
    $selector.children().each((idx2, elem2) => {
      const replaceMe = $(elem2).text().trim();
      key = key.replace(replaceMe, '');
    });
    return key.trim();
  }
  if (fieldErrorsArr.length) {
    // need to wait for updateInlineError to call; there is a settimeout of a max of 200ms
    // so make 300ms to be safe
    setTimeout(() => {
      // find error messages that are shown
      $currentView.find('.spa-input-error-message[aria-hidden="false"]').each((idx, elem) => {
        // handle case where we have id="businessName-0" and we need to
        // specific which form this is on (1 2, etc)
        const indexMatched = $(elem).attr('id').match(/(-)(\d+)/);
        let append = '';
        // if we match then put in section number
        if (indexMatched && indexMatched.length > 2) {
          append += ` Section ${parseInt(indexMatched[2], 10) + 1}.`;
        }
        // get key, which is the label of the field
        const key = getKey($(elem));
        // get value, which is the error message and if applicable the section
        const value = `${$(elem).text()}${append}`;
        const errorText = $(elem).text().trim();
        // if we actually have error text then write it at the top
        if (errorText !== '') {
          serverSideErrorMessagesList.push(`${key}:${value}`);
          showPageLevelErrorMessage$1($currentView);
        }
      });
    }, 300);
  }
}
function scrollUpForPageAndChapterTransition(state) {
  let scrollTopLocation = 0;
  if (state.previousRoute.chapter === state.currentRoute.chapter) {
    scrollTopLocation = $('#toggleMenuList').offset().top - 15;
  }

  // $(document.body).animate({scrollTop: scrollTopLocation}, 250);
  const $body = $('html, body');
  $body.animate({
    scrollTop: scrollTopLocation
  }, 250);
}
function pageTransition(previousLayout, currentLayout, $currentView, isGoBack, template, routeChanged, onMount, state) {
  $('.previous-view', $currentView).remove();
  if (!routeChanged || currentLayout === 'chapter-title-list-layout' || previousLayout === 'chapter-title-list-layout' || previousLayout === 'splash-page-layout') {
    $currentView.html(template);
    onMount();
  } else {
    $('.previous-view', $currentView).remove();
    // add to the current-view div
    if ($('.upcoming-view', $currentView).length) {
      $('.upcoming-view', $currentView).removeClass('upcoming-view').addClass('previous-view');
    }
    if (isGoBack) {
      $currentView.prepend(template);
      $('.upcoming-view', $currentView).css({
        marginLeft: '-100%'
      }).animate({
        marginLeft: '0%'
      }, 500, () => {
        $('.previous-view', $currentView).remove();
        $('.hide-show-modal').hide();
        onMount();
        scrollUpForPageAndChapterTransition(state);
      });
    } else if ($('.previous-view', $currentView).length) {
      $currentView.append(template);
      $('.upcoming-view', $currentView).css({
        width: '60%'
      });
      $('.previous-view', $currentView).animate({
        marginLeft: '-100%'
      }, 500, () => {
        $('.upcoming-view', $currentView).css({
          width: '100%'
        });
        $('.previous-view', $currentView).remove();
        $('.hide-show-modal').hide();
        onMount();
        scrollUpForPageAndChapterTransition(state);
      });
    } else {
      $('.sign-in-spinner-parent').remove(); // if user directly hits the sign-in page remove the spinner
      $currentView.append(template);
      onMount();
    }
  }
}
function getMockUrl(route) {
  const urlTemplate = spaParams.siteParams.mockInitEndpoint;
  return urlTemplate.replace(/{route\}/, route.routeName.toUpperCase());
}
function getFetch(state) {
  const mockScenarios = state.mockScenarios || '';
  return mockScenarios.toUpperCase() === 'LOCAL' ? ajaxUtility.mockFetch : ajaxUtility.fetch;
}
const popState = {
  hold: false,
  goBackEnabledFunc: event => {
    if (popState.hold) {
      popState.hold = false;
    } else {
      //  back button logic
      event.preventDefault();
      popState.hold = true;
      popState.dispatch(popState.goBack(popState.selectGoBack(popState.state, popState.renderContext)));
      popState.dispatch(popState.updateIsGoBack(true));
    }
  },
  goBackDisabledFunc: event => {
    if (popState.hold) {
      popState.hold = false;
    } else {
      event.preventDefault();
      window.history.pushState(null, document.title, popState.hash);
      spartaUILayersUtility.openLayer($('#modalLayerBackButtonModalContent'));
      // adding aria-hidden to h3 tag as it's making noise during ADA
      $('#modalLayerBackButtonModalContentSpartaUILayer').find('#modalLayerBackButtonModalContent_title').attr('aria-hidden', 'true');
    }
  },
  updateIsGoBack: isGoBackFlag => {
    const type = 'IS_GO_BACK';
    return {
      type,
      data: isGoBackFlag
    };
  }
};

/**
 * Validates the form / container
 * @param {$} $container jQuery form Container
 * @returns {{ requiredValuesProvided: Boolean, validationResults: Boolean }} Validation results.
 */
function validateContainer$1($container) {
  // if client side errors, dont allow server side to occur at all
  const queryParms = getQueryParamValues$1();
  const disableValidation = queryParms.clientValidationDisabled || 'false';
  const disabledSSN = spaParams.siteParams.bypassSSNValidation === true;
  const validationFW = spartaValidationFramework;
  if (disableValidation === 'true' && !spaParams.siteParams.isProd) {
    console.log('Client side validation has been disabled');
    return {
      requiredValuesProvided: true
    };
  }
  const requiredValuesProvided = $container.find('[required]:visible').length ? validationFW.fn.core.validateRequiredFields($container.find('[required]:visible')) : true;
  const allInputs = $container.find('input:enabled:visible,select:enabled:visible,.gis-mask-original').toArray();
  const inputsToValidate = allInputs.filter(x => !/-masked/.test($(x).attr('id')));
  const bypassNameValidation = /bypassNameValidation=true/i.test(window.location.href);
  const validationResults = inputsToValidate.map(input => {
    const $input = $(input);
    const staticRules = $input.data('validation-rules') || {};
    const dynamicRules = filteredCustomValidationMap[$input.attr('id')] || {};
    const defaultValidationRules = defaultAsciiValidation();
    const eventNames = _.compact(_.uniq([...Object.keys(staticRules), ...Object.keys(dynamicRules), ...Object.keys(defaultValidationRules)]));
    return _.every((eventNames || []).map(key => {
      if (disabledSSN && $input.attr('id') === 'ssn') {
        return true;
      }
      if ((spaParams.siteParams.bypassNameValidation || bypassNameValidation) && ['firstName', 'lastName'].indexOf($input.attr('name')) > -1) {
        const value = $input.val();
        if ((value !== null || value !== ''
        // if test or customer in name field them let them through
        ) && /test|customer/i.test(value)) {
          return true;
        }
      }
      const eventRulesStatic = staticRules[key] || [];
      const eventRulesDynamic = dynamicRules[key] || [];
      const eventRulesDefault = defaultAsciiValidation()[key] || [];
      let rulePass = true;
      let eventRules = [];
      if (Array.isArray(eventRulesStatic)) {
        eventRules = [...eventRules, ...eventRulesStatic];
      } else {
        const ruleList = Object.keys(eventRulesStatic).map(name => _.pick(eventRulesStatic, name));
        eventRules = [...eventRules, ...ruleList];
      }
      if (Array.isArray(eventRulesDynamic)) {
        eventRules = [...eventRules, ...eventRulesDynamic];
      } else {
        const ruleList = Object.keys(eventRulesDynamic).map(name => _.pick(eventRulesDynamic, name));
        eventRules = [...eventRules, ...ruleList];
      }
      eventRules = [...eventRules, ...eventRulesDefault];
      return _.every(eventRules.map(rule => {
        if (rulePass) {
          rulePass = validationFW.fn.core.validateRules($input, rule);
        }
        return rulePass;
      }));
    }));
  });
  return {
    requiredValuesProvided,
    validationResults
  };
}
function validateForm$1($currentView, dispatch) {
  const {
    requiredValuesProvided,
    validationResults
  } = validateContainer$1($currentView);
  const allOtherValidationsPass = _.every(validationResults || []);
  if (requiredValuesProvided && allOtherValidationsPass) {
    popState.hold = true;
    clearPageLevelErrorMessage$1($currentView);
    dispatch(popState.updateIsGoBack(false));
  } else {
    $('.hide-show-modal').hide();
    clientSideErrorMessagesList = _.map(clientSideErrorMessagesList, element => {
      const elements = Object.values(element);
      return elements.shift();
    });
    clientSideErrorMessagesList.map(messageObj => {
      const messageObjValuesList = Object.values(messageObj);
      return messageObjValuesList.shift();
    });
    showPageLevelErrorMessage$1($currentView);
  }
  return requiredValuesProvided && allOtherValidationsPass;
}
function wireClientValidationsAndClickEvents($currentView, selectSubmit, renderContext, selectGoBack, state, dispatch, submit, goBack, updateIsGoBack) {
  const disableValidation = spartaGlobalFunctions.getUrlParam('clientValidationDisabled');
  const validationFW = spartaValidationFramework;
  // const h1Title = state.currentRoute.h1Title;
  // $('.title-heading').text(h1Title);

  if ($currentView.find('form').length) {
    $currentView.find('form').spartaInputs({
      autoMask: true
    });
    const formValidations = {};
    $currentView.find('[data-validation-rules]').each(function () {
      formValidations[$(this).attr('id')] = $(this).data('validation-rules');
    });
    if (!spaParams.siteParams.isProd && disableValidation === 'true') {
      console.log('Client side validation has been disabled');
    } else {
      //  bind validation from jcr
      validationFW.fn.core.bindValidationRules(formValidations, true);
    }
  }
  $currentView.find('.btn-continue').off().on('click', event => {
    const submitObject = selectSubmit(state, event, renderContext);
    if (submitObject !== false) {
      $('.hide-show-modal').show();
      dispatch(submit(submitObject));
    }
  });
  $currentView.find('.btn-save-and-exit').off().on('click', event => {
    const values = selectSubmit(state, event, renderContext);
    if (values !== false) {
      $('.hide-show-modal').show();
      dispatch(submit({
        ...values,
        saveAndExit: true
      }));
    }
  });
  window.removeEventListener('popstate', popState.goBackEnabledFunc);
  window.removeEventListener('popstate', popState.goBackDisabledFunc);
  popState.hold = false;
  popState.hash = document.location.hash;
  window.history.pushState(null, document.title, popState.hash);
  const backButtons = $currentView.find('.btn-back');
  if (backButtons.length > 0) {
    backButtons.off().on('click', () => {
      $('.hide-show-modal').show();
      animationUtility.toggleSaveContinueSpinner('on', 'back');

      //  back button logic
      popState.hold = true;
      dispatch(goBack(selectGoBack(state, renderContext)));
      dispatch(updateIsGoBack(true));
    });
    popState.dispatch = dispatch;
    popState.goBack = goBack;
    popState.selectGoBack = selectGoBack;
    popState.updateIsGoBack = updateIsGoBack;
    popState.state = state;
    popState.renderContext = renderContext;
    window.addEventListener('popstate', popState.goBackEnabledFunc);
  } else {
    window.addEventListener('popstate', popState.goBackDisabledFunc);
  }
  $('.hide-show-modal').hide();
}
function allowNextRouteChange$1() {
  popState.hold = true;
}
function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookies = decodeURIComponent(document.cookie);
  const cookies = decodedCookies.split(';');
  const cookie = cookies.filter(c => {
    const cleanCookie = c.trim();
    return cleanCookie.indexOf(name) === 0;
  });
  if (cookie && cookie.length) {
    return cookie[0].trim().substring(name.length, cookie[0].length);
  }
  return null;
}
function logEventToServer$1(messageId, message, priority, state = {}) {
  const xhttp = new XMLHttpRequest();
  xhttp.open('POST', '/apply-now-services/home-loans/rest/dma/logMessage/v1', true);
  xhttp.setRequestHeader('Accept', 'application/json');
  xhttp.setRequestHeader('Content-Type', 'application/json');
  const SID = getCookie('SID');
  let appId;
  if (state && state.dataReceived) {
    appId = state.dataReceived.applicationId;
  }
  const messageText = `${message} - DME application ID ${appId} - SID: ${SID}`;
  xhttp.send(JSON.stringify({
    messageId,
    messageText,
    priority
  }));
}
function configureLogEvent(state = {}) {
  spartaEventsUtility.unsubByEvent('log-event');
  spartaEventsUtility.sub('log-event', ev => {
    logEventToServer$1(ev.data.messageId, ev.data.messageText, ev.data.priority, state);
  });
}

/**
 * check the current browser
 * @returns {Object} contain one property with the current browser name set to true, and everything else is false.
 * The followings are all the returning properties: isOpera, isChrome, isSafari, isFirefox, isIE, isEdge.
 */
const browserName$1 = (() => {
  const name = {
    isOpera: false,
    isChrome: false,
    isSafari: false,
    isFirefox: false,
    isIE: false,
    isEdge: false
  };
  if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
    name.isOpera = true;
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    name.isChrome = true;
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    name.isSafari = true;
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    name.isFirefox = true;
  } else if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode === true) {
    name.isIE = true;
  } else if (navigator.userAgent.indexOf('Edge')) {
    name.isEdge = true;
  }
  return name;
})();
var utils = {
  replaceValueRules,
  addBackendValidation,
  pageTransition,
  getMockUrl,
  getFetch,
  wireClientValidationsAndClickEvents,
  allowNextRouteChange: allowNextRouteChange$1,
  validateForm: validateForm$1,
  getQueryParamValues: getQueryParamValues$1,
  logEventToServer: logEventToServer$1,
  validateContainer: validateContainer$1,
  showPageLevelErrorMessage: showPageLevelErrorMessage$1,
  clearPageLevelErrorMessage: clearPageLevelErrorMessage$1,
  browserName: browserName$1,
  configureLogEvent
};

/* eslint-disable require-jsdoc */

/**
 * For viewtypes System-down and timeout redirect users to OFF-RAMP
 * @param {Function} dispatch to call updateRoute and updateBehaveLikeRouteChange functions
 */
function redirectUserToOffRamp(dispatch) {
  if (spaParams.siteParams.isLocal) {
    return;
  }
  const isCurrentRouteOffRamp = window.location.hash === '#off-ramp';
  // go to 'off-ramp' page only if current route isn't 'off-ramp'
  // If user try to hit the back button multiple times then ristrict the multiple init calls
  if (!isCurrentRouteOffRamp) {
    const response = {
      nextView: 'off-ramp'
    }; // Creating mock response to redirect users to OFF-RAMP
    updateRouteFromResponse(response, dispatch);
  }
}
function render(response) {
  return (dispatch, getState) => {
    const state = getState();
    state.renderActions.actions.forEach(action => dispatch(action(response)));
    if (state.renderActions.routeActions[state.currentRoute.routeName]) {
      state.renderActions.routeActions[state.currentRoute.routeName].forEach(action => {
        dispatch(action(response));
      });
    }
  };
}
function initializePage(event) {
  return dispatch => {
    const currentRoute = routes$1.getCurrentRoute();
    const previousModule = routes$1.getPreviousRoute(event.oldURL);
    dispatch(routeUpdated(currentRoute));
    dispatch(updatePreviousRoute(previousModule));
    dispatch(init(currentRoute));
  };
}
function init(route) {
  return (dispatch, getState) => {
    const state = getState();
    const fetch = utils.getFetch(state);
    utils.configureLogEvent(state);
    function startRender(response) {
      setTimeout(() => {
        dispatch(dataReceived$1(response));
        dispatch(render(response));
      }, 25);
    }

    // if value of nextView is 'system-down' or 'timeout' and current view is not in the exception views list, then show 'off-ramp'
    // returns boolean value
    function isOffRampRequired() {
      if (spaParams.siteParams.isLocal) {
        return;
      }
      const exceptionList = ['#landing', '#purchase-gating-question', '#save-and-exit', '#refinance-goals', '#off-ramp'];
      const currentRoute = window.location.hash;
      const hasExceptionView = exceptionList.includes(currentRoute);
      return !hasExceptionView;
    }
    function doInit() {
      if (route.endpoints && route.endpoints.init) {
        const url = route.endpoints.init;
        return fetch(url).then(response => {
          const {
            nextView
          } = response;
          const invalidViewList = ['system-down', 'timeout'];
          if (nextView && invalidViewList.includes(nextView.toLowerCase())) {
            const changeViewToOffRamp = isOffRampRequired();
            if (changeViewToOffRamp) {
              redirectUserToOffRamp(dispatch);
              return;
            }
          }
          const {
            isCartRetrieved
          } = getState();
          if (!isCartRetrieved && response.isAuthenticated) {
            dmaCartUtility.getTheCart().then(() => dispatch(updateCartRetrieved(true))).catch(e => console.error('error retrieving cart', e));
          }
          startRender(response);
          if (response) {
            savePhoneNumber(dispatch, getState, response);
            saveMloInformation(dispatch, response);
          }
        }).catch(e => {
          let messageText;
          if (e.statusText) {
            const responseHeaders = e.getAllResponseHeaders();
            messageText = `Init call failed to url "${url}", with result ${e.statusText} and error ${e.status} and response headers ${responseHeaders}. UI redirected application flow to off-ramp.`;
          } else {
            messageText = `Module init failed: ${e.message}./nStack trace: ${e.stack}`;
          }
          spartaEventsUtility.pub('log-event', {
            messageId: 'dma-init-failed',
            messageText,
            priority: 'ERROR'
          });
          const isCurrentRouteOffRamp = window.location.hash === '#off-ramp';
          // on init call failure if the page hash is changed to 'off-ramp', then render the 'off-ramp' page and prevent multiple call failurs
          if (isCurrentRouteOffRamp) {
            startRender({
              nextView: 'off-ramp'
            });
            return;
          }
          redirectUserToOffRamp(dispatch);
        });
      }
      dispatch(render({}));
    }
    const mockScenarios = state.mockScenarios || '';
    if (mockScenarios.toUpperCase() === 'SERVER') {
      const mockUrl = utils.getMockUrl(route);
      return fetch(mockUrl).then(() => doInit()).catch((jqXHR, textStatus, errorThrown) => {
        console.error(errorThrown);
        // todo: handle the exception
      });
    }
    return doInit();
  };
}
function updateRouteFromResponse(response, dispatch) {
  const nextView = response.nextView ? response.nextView.toLowerCase() : '';
  const knownRoute = routes$1.isKnownRoute(nextView);
  if (knownRoute) {
    const route = routes$1.getRoute(nextView);
    const isSameRoute = `#${route.routeName}` === window.location.hash;
    dispatch(updateRoute(route));
    if (isSameRoute) {
      dispatch(initializePage({
        oldURL: document.URL
      }));
      // if the route is the same, but we want the page to animate and repaint
      // like past-living-situation, we need an action that behaves like a route change
      dispatch(updateBehaveLikeRouteChange(true));
    } else {
      dispatch(updateBehaveLikeRouteChange(false));
    }
  } else {
    spartaEventsUtility.pub('log-event', {
      messageId: 'dma-update-route-failed',
      messageText: `Response.NextView came as ${response.nextView}, which is unknown for UI, redirected application flow to off-ramp.`,
      priority: 'ERROR'
    });
    redirectUserToOffRamp(dispatch);
  }
}
function submit(data, url, method = 'POST', skipValidations = false, skipAnimationOnBtn = false) {
  return (dispatch, getState) => {
    if (skipValidations || utils.validateForm($('.current-view'), dispatch)) {
      const state = getState();
      const fetch = utils.getFetch(getState());
      const {
        type,
        messageCodes
      } = state.dataReceived;
      const allData = {
        messageCodes,
        ...data
      };
      const {
        inFlight
      } = state;
      const freshObj = data && type ? utils.replaceValueRules({
        ...allData,
        type
      }) : allData;
      if (!skipAnimationOnBtn) animationUtility.toggleSaveContinueSpinner('on', 'continue');
      // close all info layers
      spartaUILayersUtility.closeLayer($('.spa-ui-info'));
      const submitUrl = url || state.currentRoute.endpoints.submit;
      if (!inFlight) {
        dispatch(requestInFlight(true));
        fetch(submitUrl, method, freshObj || null).then(response => {
          animationUtility.waitScreenStop();
          const validation = response || {};
          spartaUILayersUtility.closeLayer($('.spa-ui-modal'));
          dispatch(requestInFlight(false));
          animationUtility.toggleSaveContinueSpinner('off', 'continue');
          if ($('.current-view').is(':visible') && validation.valid === false) {
            utils.addBackendValidation(validation);
            $('.hide-show-modal').hide();
            dispatch(dataSubmitted$1(data));
          } else {
            dispatch(dataSubmitted$1(data));
            updateRouteFromResponse(response, dispatch);
          }
        }).catch(e => {
          dispatch(requestInFlight(false));
          $('.hide-show-modal').hide();
          animationUtility.waitScreenStop();
          spartaUILayersUtility.closeLayer($('.spa-ui-modal'));
          let messageText;
          if (e.statusText) {
            const responseHeaders = e.getAllResponseHeaders();
            messageText = `Submit call failed to url "${url}", with result ${e.statusText} and error ${e.status} and response headers ${responseHeaders}. UI redirected application flow to off-ramp.`;
          } else {
            messageText = `Module Submit failed: ${e.message}./nStack trace: ${e.stack}`;
          }
          spartaEventsUtility.pub('log-event', {
            messageId: 'dma-submit-failed',
            messageText,
            priority: 'ERROR'
          });
          redirectUserToOffRamp(dispatch);
        });
      }
    }
  };
}
function savePhoneNumber(dispatch, getState, response) {
  const state = getState();
  const phoneNumber = response.subCampPhoneNumber ? response.subCampPhoneNumber : state.subCampPhoneNumber;
  dispatch(subCampPhoneNumber$1(phoneNumber));
}
function subCampPhoneNumber$1(data) {
  return {
    type: constants$1.PHONE_NUMBER_RECEIVED,
    data
  };
}
function mloInformation$1(data) {
  return {
    type: constants$1.MLO_DETAILS_RECEIVED,
    data
  };
}
function saveMloInformation(dispatch, response) {
  if (response.mloInformation) {
    dispatch(mloInformation$1(response.mloInformation));
  }
}
function dataReceived$1(data) {
  return {
    type: constants$1.DATA_RECEIVED,
    data
  };
}
function dataSubmitted$1(data) {
  return {
    type: constants$1.DATA_SUBMITTED,
    data
  };
}
function goBack(goBackData = {}) {
  $('.hide-show-modal').show();
  const {
    data
  } = goBackData;
  const options = goBackData.options || {};
  const httpMethod = options.httpMethod || 'GET';
  return (dispatch, getState) => {
    const state = getState();
    const fetch = utils.getFetch(state);
    const {
      inFlight
    } = state;
    spartaUILayersUtility.closeLayer($('.spa-ui-info')); // close all info layers
    spartaUILayersUtility.closeLayer($('.spa-ui-modal')); // close all modal layers
    const url = state.currentRoute.endpoints['go-back'];
    if (!inFlight) {
      dispatch(requestInFlight(true));
      fetch(url, httpMethod, data).then(response => {
        updateRouteFromResponse(response, dispatch);
        dispatch(requestInFlight(false));
      }).catch(e => {
        dispatch(requestInFlight(false));
        $('.hide-show-modal').hide();
        let messageText;
        if (e.statusText) {
          const responseHeaders = e.getAllResponseHeaders();
          messageText = `Goback call failed to url "${url}", with result ${e.statusText} and error ${e.status} and response headers ${responseHeaders}. UI redirected application flow to off-ramp.`;
        } else {
          messageText = `Module goback failed: ${e.message}./nStack trace: ${e.stack}`;
        }
        spartaEventsUtility.pub('log-event', {
          messageId: 'dma-goback-failed',
          messageText,
          priority: 'ERROR'
        });
        redirectUserToOffRamp(dispatch);
      });
    }
  };
}
function goToChapter(selectedChapter) {
  $('.hide-show-modal').show();
  return (dispatch, getState) => {
    const state = getState();
    const fetch = utils.getFetch(state);
    spartaUILayersUtility.closeLayer($('.spa-ui-info')); // close all info layers
    const url = spaParams.siteParams.goToChapterEndpoint;
    const {
      inFlight
    } = state;
    if (!inFlight) {
      dispatch(requestInFlight(true));
      fetch(url, 'POST', {
        selectedChapter,
        type: 'baseDMADTO'
      }).then(response => {
        updateRouteFromResponse(response, dispatch);
        dispatch(requestInFlight(false));
      }).catch(e => {
        dispatch(requestInFlight(false));
        $('.hide-show-modal').hide();
        let messageText;
        if (e.statusText) {
          const responseHeaders = e.getAllResponseHeaders();
          messageText = `GoToChapter call failed to url "${url}", with result ${e.statusText} and error ${e.status} and response headers ${responseHeaders}. UI redirected application flow to off-ramp.`;
        } else {
          messageText = `Module goToChapter failed: ${e.message}./nStack trace: ${e.stack}`;
        }
        spartaEventsUtility.pub('log-event', {
          messageId: 'dma-goToChapter-failed',
          messageText,
          priority: 'ERROR'
        });
        redirectUserToOffRamp(dispatch);
      });
    }
  };
}
function requestInFlight(inFlight) {
  return {
    type: constants$1.IN_FLIGHT,
    data: inFlight
  };
}
function routeUpdated(route) {
  return {
    type: constants$1.ROUTE_UPDATED,
    data: route
  };
}
function updatePreviousRoute(route) {
  return {
    type: constants$1.PREVIOUS_ROUTE,
    data: route
  };
}
function updateIsGoBack(isGoBackFlag) {
  return {
    type: constants$1.IS_GO_BACK,
    data: isGoBackFlag
  };
}

// this function
function updateBehaveLikeRouteChange(behaveLikeRouteChange) {
  return {
    type: constants$1.BEHAVE_LIKE_ROUTE_CHANGE,
    data: behaveLikeRouteChange
  };
}
function updateRoute(route) {
  utils.allowNextRouteChange();
  window.location.hash = `#${route.routeName}`;
  return {
    type: constants$1.UPDATE_ROUTE
  };
}
function updateOnUnMountEvent(onUnMount) {
  return {
    type: constants$1.UPDATE_ON_UNMOUNT_EVENT,
    event: onUnMount
  };
}
function getPartials($module) {
  const $templates = $module.find('[type="text/x-handlebars-template"]');
  return _.fromPairs($templates.map(function () {
    const $template = $(this);
    const partialName = $template.data('partial-name');
    const compiledTemplate = hbs.compile($template.html());
    hbs.registerPartial(partialName, compiledTemplate);
    return [[partialName, compiledTemplate]];
  }));
}
function updateDataSources(data) {
  return {
    type: constants$1.UPDATE_DATA_SOURCES,
    data
  };
}
function getRenderAction(copy, $module, partials, selectors, lifecycleMethods) {
  function maybeMount(dispatch, getState) {
    if ($module.length && selectors && selectors.onMount) {
      const {
        onMount
      } = selectors;
      if (onMount && onMount.oncePerRoute) {
        selectors.onMount($module, dispatch, getState);
      }
    }
  }
  const selectSubmit = selectors && selectors.submit ? selectors.submit : () => formsUtility.getFormValues($('.current-view:visible form'));
  const selectGoBack = selectors && selectors.back || (data => data);
  const beforeGoBack = lifecycleMethods && lifecycleMethods.beforeGoBack;
  return response => (dispatch, getState) => {
    const currentRoute = routes$1.getCurrentRoute();
    const {
      routeName
    } = currentRoute;
    // Sparta V6 Migration Note - .replace was added since V6 now adds the full
    // module name to data-module.
    let moduleName = $module.data('module');
    if (moduleName != null) {
      moduleName = moduleName.replace(/digital-mortgage-application-/g, '');
    }
    let state = getState();
    if (currentRoute) {
      const $requestedLayout = $(`.dma-layout[data-dma-layout="${currentRoute.layout}"]`);
      const $otherLayouts = $(`.dma-layout:not([data-dma-layout="${currentRoute.layout}"])`);
      $otherLayouts.addClass('hide');
      $requestedLayout.removeClass('hide');
    }
    if (currentRoute && _.has(currentRoute.modules, moduleName)) {
      const routeModule = currentRoute.modules[moduleName];
      const templateName = routeModule.partial || routeModule || 'default';
      const template = partials[templateName];
      const dataSource = routeModule.dataSource || 'copy';
      dispatch(updateDataSources({
        [dataSource]: copy[dataSource]
      }));
      const selectRender = selectors && selectors.render || (context => ({
        ...context[dataSource],
        ...getState(),
        ...response
      }));
      if (template) {
        const renderContext = {
          ...selectRender(copy, getState(), response, dataSource),
          currentRoute: copy[dataSource] && copy[dataSource].routes ? copy[dataSource].routes[routeName] : routeName,
          global: spaParams.global[spaParams.language]
        };
        state = getState();
        const currentLayout = state.currentRoute.layout;
        const previousLayout = state.previousRoute.layout;
        const viewNeedsAnimation = currentLayout === 'chapter-section-layout' && $module.closest('.main-content').length;
        const $currentView = viewNeedsAnimation ? $('.current-view') : $module;
        const renderTemplate = viewNeedsAnimation ? `<div class="upcoming-view"><p id="announcementContainer" aria-live="assertive" aria-atomic="true" aria-relevant="additions" class="ada-hidden"></p>${template(renderContext)}</div>` : template(renderContext);
        const {
          isGoBack,
          isRenderLocal
        } = state;
        const previousRouteName = state.previousRoute.routeName;
        const isTheRouteSame = previousRouteName && state.currentRoute.routeName !== previousRouteName;
        const routeChanged = !isRenderLocal && isTheRouteSame || state.behaveLikeRouteChange;

        /* eslint-disable no-inner-declarations */
        const onMount = function onMount() {
          // we are setting updateIsRenderLocal to false so that the flag in the Redux state is reset back
          // to its default state. Individual modules sucah as income.js set this flag as true when
          // adding another form section to the page
          dispatch(updateIsRenderLocal(false));
          function goBackWithHook(data = {}) {
            return innerDispatch => {
              beforeGoBack();
              innerDispatch(goBack(data));
            };
          }
          if (selectors && selectors.onMount) {
            utils.wireClientValidationsAndClickEvents($('.current-view'), selectSubmit, renderContext, selectGoBack, state, dispatch, submit, beforeGoBack ? goBackWithHook : goBack, updateIsGoBack);
            selectors.onMount($currentView, dispatch, getState);
          }
        };

        // call onUnMount of the previous route
        if (state.onUnMount && typeof state.onUnMount === 'function') {
          state.onUnMount(copy, state);
        }
        // now update the onUnMount
        const onUnMount = selectors && selectors.onUnMount ? selectors.onUnMount : null;
        dispatch(updateOnUnMountEvent(onUnMount));

        // renders the new route HTML in the current-view
        animationUtility.toggleSpinnerOnButton('off');
        if (viewNeedsAnimation) {
          utils.pageTransition(previousLayout, currentLayout, $currentView, isGoBack, renderTemplate, routeChanged, onMount, state);
        } else {
          $currentView.html(renderTemplate);
          onMount();
        }
      } else {
        maybeMount(dispatch, getState);
      }
    } else {
      maybeMount(dispatch, getState);
    }
  };
}
function addRenderAction(renderAction, routeList) {
  return {
    type: constants$1.ADD_RENDER_ACTION,
    data: {
      renderAction,
      routeList
    }
  };
}
function updatePartials(data) {
  return {
    type: constants$1.UPDATE_PARTIALS,
    data
  };
}
function initModule($module, selectors, lifecycleMethods, routeList, routeConfig, module) {
  return dispatch => {
    if (routeList && routeConfig) {
      routeList.forEach(routeName => {
        routes$1.putRoute(routeName, routeConfig);
      });
    }
    if ($module) {
      const $contentScript = $module.find('.static-content').first();
      const copy = $contentScript.length ? JSON.parse($contentScript.text()) : {};
      const partials = module ? module.settings.config.partials : getPartials($module);
      dispatch(updatePartials(partials));
      const renderAction = getRenderAction(copy, $module, partials, selectors, lifecycleMethods);
      dispatch(addRenderAction(renderAction, routeList));
    }
  };
}
function updateMockScenarios(data) {
  return {
    type: constants$1.UPDATE_MOCK_SCENARIOS,
    data
  };
}
function updateCountryLists(data) {
  return {
    type: constants$1.UPDATE_COUNTRY_LISTS,
    data
  };
}
function updateOccupationList(data) {
  return {
    type: constants$1.UPDATE_OCCUPATION_LIST,
    data
  };
}
function updateResidencyTypeList(data) {
  return {
    type: constants$1.UPDATE_RESIDENCY_TYPE_LIST,
    data
  };
}
function updateResidencyDocumentList(data) {
  return {
    type: constants$1.UPDATE_RESIDENCY_DOCUMENT_LIST,
    data
  };
}
function updateCartRetrieved(data) {
  return {
    type: constants$1.UPDATE_CART_RETRIEVED,
    data
  };
}
function combineResults(memo, result) {
  const listName = Object.keys(result)[0];
  const usaIndex = _.findIndex(result[listName], option => option.value === 'US');
  if (usaIndex >= 0) {
    const options = [result[listName][usaIndex], ...result[listName].slice(0, usaIndex), ...result[listName].slice(usaIndex + 1)];
    return {
      ...memo,
      [listName]: options
    };
  }
  return {
    ...memo,
    ...result
  };
}
function startApp() {
  animationUtility.toggleSaveContinueSpinner('on');
  return (dispatch, getState) => {
    const state = getState();
    // cache both country and occupation psa lists
    const countryEndpoints = spaParams.siteParams.psaCountryEndpoints;
    const occupationEndpoint = spaParams.siteParams.psaOccupationEndpoints;
    const residencyEndpoint = spaParams.siteParams.psaResidencyEndpoints;
    const endpoints = {
      ...countryEndpoints,
      ...occupationEndpoint,
      ...residencyEndpoint
    };
    const COUNTRY = 'COUNTRY';
    const OCCUPATION = 'OCCUPATION';
    const RESIDENCY_TYPE = 'RESIDENCY_TYPE';
    const RESIDENCY_DOCUMENT = 'RESIDENCY_DOCUMENT';
    const endPointTypeMapping = {
      CITIZENSHIP: COUNTRY,
      DUAL_CITIZENSHIP: COUNTRY,
      RESIDENCE: COUNTRY,
      OCCUPATION,
      RESIDENCY_TYPE,
      RESIDENCY_DOCUMENT
    };
    const listNames = Object.keys(endpoints);
    const promises = listNames.map(name => {
      const fetch = utils.getFetch(state);
      return fetch(endpoints[name], 'GET', null, {
        cache: true
      }).then(result => {
        const type = endPointTypeMapping[name];
        if (['CITIZENSHIP', 'DUAL_CITIZENSHIP'].indexOf(name) !== -1) {
          // Reject promise when no results are found
          if (!result.length) {
            const message = `Get call failed to url "${endpoints[name]}", with result nextView: ${result.nextView}`;
            return Promise.reject(null, null, message);
          }
          return Promise.resolve({
            [name]: result.filter(c => c.value !== 'US'),
            type
          });
        }
        return Promise.resolve({
          [name]: result,
          type
        });
      });
    });
    Promise.all(promises).then(results => {
      const countryResults = results.filter(x => x.type === COUNTRY)
      // don't need type anymore so just remove it so it doesn't get into state
      .map(e => {
        delete e.type;
        return e;
      });
      // we first need to remove a few values from array that really aren't occupations
      // and we also need to sort the list
      const occupationResults = results.find(x => x.type === OCCUPATION)[OCCUPATION].filter(e => ['Homemaker', 'Retired', 'Unemployed'].indexOf(e.text) === -1).sort((a, b) => a.text.localeCompare(b.text));
      const countryResponse = _.reduce(countryResults, combineResults, {});
      const residencyTypeResults = results.find(x => x.type === RESIDENCY_TYPE);
      const residencyDocumentResults = results.find(x => x.type === RESIDENCY_DOCUMENT);
      dispatch(updateCountryLists(countryResponse));
      dispatch(updateOccupationList({
        OCCUPATION: occupationResults
      }));
      dispatch(updateResidencyTypeList(residencyTypeResults));
      dispatch(updateResidencyDocumentList(residencyDocumentResults));
      const currentRoute = routes$1.getCurrentRoute();
      if (!window.location.hash) {
        dispatch(updateRoute(currentRoute));
      } else {
        dispatch(routeUpdated(currentRoute));
        dispatch(init(currentRoute));
      }
    }).catch(e => {
      spartaEventsUtility.pub('log-event', {
        messageId: 'dma-psa-endpoint-call-failed',
        messageText: e,
        priority: 'INFO'
      });
      redirectUserToOffRamp(dispatch);
    });
  };
}
function updateIsRenderLocal(isRenderLocalFlag) {
  return {
    type: constants$1.IS_RENDER_LOCAL,
    data: isRenderLocalFlag
  };
}
var actions = {
  routeUpdated,
  updatePreviousRoute,
  updateRoute,
  render,
  initModule,
  updateMockScenarios,
  startApp,
  init,
  submit,
  goToChapter,
  initializePage,
  updateIsRenderLocal,
  requestInFlight,
  goBack
};

function onUnMount(state = {}, action) {
  switch (action.type) {
    case constants$1.UPDATE_ON_UNMOUNT_EVENT:
      return action.event;
    default:
      return state;
  }
}
function currentRoute(state = {}, action) {
  switch (action.type) {
    case constants$1.ROUTE_UPDATED:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function previousRoute(state = {}, action) {
  switch (action.type) {
    case constants$1.PREVIOUS_ROUTE:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function isGoBack(state = false, action) {
  switch (action.type) {
    case constants$1.IS_GO_BACK:
      return action.data;
    default:
      return state;
  }
}
function behaveLikeRouteChange(state = false, action) {
  switch (action.type) {
    case constants$1.BEHAVE_LIKE_ROUTE_CHANGE:
      return action.data;
    default:
      return state;
  }
}
function mockScenarios(state = '', action) {
  switch (action.type) {
    case constants$1.UPDATE_MOCK_SCENARIOS:
      return action.data;
    default:
      return state;
  }
}
function renderActions(state, action) {
  if (!state) {
    // eslint-disable-next-line no-param-reassign
    state = {
      actions: [],
      routeActions: {}
    };
  }
  switch (action.type) {
    case constants$1.ADD_RENDER_ACTION:
      if (action.data.routeList) {
        action.data.routeList.forEach(route => {
          if (state.routeActions[route]) {
            state.routeActions[route].push(action.data.renderAction);
          } else {
            // eslint-disable-next-line no-param-reassign
            state.routeActions[route] = [action.data.renderAction];
          }
        });
      } else {
        state.actions.push(action.data.renderAction);
      }
      return state;
    // [...state, action.data];

    default:
      return state;
  }
}
function dataReceived(state = {}, action) {
  switch (action.type) {
    case constants$1.DATA_RECEIVED:
      return action.data;
    default:
      return state;
  }
}
function subCampPhoneNumber(state = {}, action) {
  switch (action.type) {
    case constants$1.PHONE_NUMBER_RECEIVED:
      return action.data;
    default:
      return state;
  }
}
function dataSubmitted(state = {}, action) {
  switch (action.type) {
    case constants$1.DATA_SUBMITTED:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function countryLists(state = {}, action) {
  switch (action.type) {
    case constants$1.UPDATE_COUNTRY_LISTS:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function occupationList(state = {}, action) {
  switch (action.type) {
    case constants$1.UPDATE_OCCUPATION_LIST:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function residencyTypeList(state = {}, action) {
  switch (action.type) {
    case constants$1.UPDATE_RESIDENCY_TYPE_LIST:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function residencyDocumentList(state = {}, action) {
  switch (action.type) {
    case constants$1.UPDATE_RESIDENCY_DOCUMENT_LIST:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function partials(state = {}, action) {
  switch (action.type) {
    case constants$1.UPDATE_PARTIALS:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function dataSources(state = {}, action) {
  switch (action.type) {
    case constants$1.UPDATE_DATA_SOURCES:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
function isRenderLocal(state = false, action) {
  switch (action.type) {
    case constants$1.IS_RENDER_LOCAL:
      return action.data;
    default:
      return state;
  }
}
function inFlight(state = false, action) {
  switch (action.type) {
    case constants$1.IN_FLIGHT:
      return action.data;
    default:
      return state;
  }
}
function mloInformation(state = {}, action) {
  switch (action.type) {
    case constants$1.MLO_DETAILS_RECEIVED:
      return action.data;
    default:
      return state;
  }
}
function isCartRetrieved(state = false, action) {
  switch (action.type) {
    case constants$1.UPDATE_CART_RETRIEVED:
      return action.data;
    default:
      return state;
  }
}
var reducers = {
  onUnMount,
  currentRoute,
  previousRoute,
  isGoBack,
  mockScenarios,
  renderActions,
  dataReceived,
  dataSubmitted,
  countryLists,
  occupationList,
  residencyTypeList,
  residencyDocumentList,
  partials,
  dataSources,
  behaveLikeRouteChange,
  isRenderLocal,
  subCampPhoneNumber,
  mloInformation,
  inFlight,
  isCartRetrieved
};

/* eslint-disable require-jsdoc */

/* global window:false, document:false */
/* globals spaParams */

let cartSupported = true;
let mda = false;

/**
 * @method configureStore
 * @desc creates and initializes a Redux store object
 * @param {Object} fullReducers - all the reducers needed for the application state
 * @returns {Object} a Redux store object
 */

function configureStore(fullReducers) {
  const createStore = Redux.compose(Redux.applyMiddleware(Redux.thunk), window.devToolsExtension ? window.devToolsExtension() : f => f)(Redux.createStore);
  const store = createStore(fullReducers, {});

  // check if module is hot
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      /* eslint-disable global-require */
      const nextReducer = require('./reducers');
      store.replaceReducer(nextReducer);
    });
  }
  return store;
}
const store = configureStore(Redux.combineReducers({
  ...reducers,
  ...formsUtility.reducers
}));
function dispatch(action) {
  store.dispatch(action);
}
function subscribeToStore(callback) {
  store.subscribe(() => {
    const currentState = store.getState();
    callback(currentState);
  });
}
const helperArr = {
  ...checkboxHelper,
  ...comparisonsHelper,
  ...jsonHelper,
  ...pictureHelper,
  ...radioButtonHelper,
  ...selectHelper,
  ...spartaHelper,
  ...buttonHelper,
  ...circleButtonHelper,
  ...textInputsHelper,
  ...utilsHelper,
  ...dmaHelper,
  ...currencyHelper,
  ...textMaskingHelper,
  ...svgHelper,
  ...equalHelper,
  ...showHideHelper,
  ...squeezeboxHelper,
  ...styleUtility.getHelpers()
};
Object.keys(helperArr).forEach(key => {
  hbs.registerHelper(key, helperArr[key]);
});

// IE Fallback
if (!window.HashChangeEvent) {
  let lastURL = document.URL;
  window.addEventListener('hashchange', event => {
    Object.defineProperty(event, 'oldURL', {
      enumerable: true,
      configurable: true,
      value: lastURL
    });
    lastURL = document.URL;
  });
}
window.addEventListener('hashchange', e => {
  dispatch(actions.initializePage(e));
});
if (spaParams.siteParams.allowDebugging) {
  const mockScenarios = spartaGlobalFunctions.getUrlParam('mock');
  dispatch(actions.updateMockScenarios(mockScenarios));
}

// dispatch(actions.getCountryLists());

function getCurrentRoute() {
  return routes$1.getCurrentRoute();
}

// Setup cart supported functions
if (/ese=false/i.test(window.location.href)) {
  // eslint-disable-line
  cartSupported = false;
}
if (/wrap=mda/i.test(window.location.href)) {
  // eslint-disable-line
  mda = true;
}
if (window.localStorage) {
  const localValue = window.localStorage.getItem('cartSupported');
  if (localValue === null) {
    window.localStorage.setItem('cartSupported', cartSupported);
  } else {
    cartSupported = localValue === 'true';
  }
  const localMDAValue = window.localStorage.getItem('isMDA');
  if (localMDAValue === null) {
    window.localStorage.setItem('isMDA', mda);
  } else {
    mda = localMDAValue === 'true';
  }
}

/**
 * Checks whether the cart is supported or not
 * @returns {Boolean} whether the cart is supported or not
 */
function isCartSupported() {
  return cartSupported;
}

/**
 * Checks if we're on MDA
 * @returns {Boolean} Whether or not we're on MDA
 */
function isMDA() {
  return mda;
}
const {
  allowNextRouteChange,
  validateForm,
  validateContainer,
  getQueryParamValues,
  showPageLevelErrorMessage,
  clearPageLevelErrorMessage,
  logEventToServer,
  browserName
} = utils;

// const {
//   isCartSupported,
//   isMDA,
// } = cartSupportedUtility;

var index = {
  actions,
  constants: constants$1,
  getCurrentRoute,
  dispatch,
  subscribeToStore,
  allowNextRouteChange,
  ...customClientValidation,
  validateForm,
  validateContainer,
  getQueryParamValues,
  showPageLevelErrorMessage,
  clearPageLevelErrorMessage,
  logEventToServer,
  browserName,
  isCartSupported,
  isMDA
};

export { index as default };
